import { tuple } from '../_utils/type';
export var SearchTypes = tuple('basis', 'quick-search', 'panel');
export var BorderTypes = tuple('none', 'underline', 'bordered');
export var SearchSizeTypes = tuple('large', 'middle', 'small');